import { useEffect, useState } from 'react';
import { Table, Card, Input, Select, Button, Tag, Modal, Form, message, Typography, Space, Popconfirm } from 'antd';
import { SearchOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import api from '../../api/axios';

const { Title } = Typography;

const STATUS_MAP = { 1: { t: 'Aktiv', c: 'green' }, 2: { t: 'Nofaol', c: 'orange' }, 3: { t: 'Bloklangan', c: 'red' }, 4: { t: "O'chirilgan", c: 'default' } };

export default function GovUsersPage() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [roleFilter, setRoleFilter] = useState(null);
  const [roles, setRoles] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [form] = Form.useForm();

  const fetchData = async (p = page) => {
    setLoading(true);
    try {
      const params = { page: p, limit: 20 };
      if (search) params.search = search;
      if (roleFilter) params.role = roleFilter;
      const r = await api.get('/admingov/users', { params });
      setData(r.data.data);
      setTotal(r.data.total);
    } catch (e) { message.error('Xatolik'); }
    setLoading(false);
  };

  useEffect(() => {
    fetchData(1);
    api.get('/admingov/roles').then(r => setRoles(r.data.data)).catch(() => {});
  }, []);

  useEffect(() => { fetchData(1); }, [search, roleFilter]);

  const handleEdit = (record) => {
    setEditUser(record);
    form.setFieldsValue(record);
    setEditModal(true);
  };

  const handleSave = async () => {
    const vals = await form.validateFields();
    try {
      await api.put(`/admingov/users/${editUser.id}`, vals);
      message.success('Saqlandi');
      setEditModal(false);
      fetchData();
    } catch { message.error('Xatolik'); }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/admingov/users/${id}`);
      message.success("O'chirildi");
      fetchData();
    } catch { message.error('Xatolik'); }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: 'Ism', dataIndex: 'fullname' },
    { title: 'Telefon', dataIndex: 'phone' },
    { title: 'Rol', dataIndex: 'role_name', render: (t) => <Tag>{t}</Tag> },
    {
      title: 'Status', dataIndex: 'user_statusses_id',
      render: (v) => { const s = STATUS_MAP[v]; return s ? <Tag color={s.c}>{s.t}</Tag> : v; }
    },
    { title: 'Yaratilgan', dataIndex: 'created', render: v => v ? new Date(v).toLocaleDateString('uz-UZ') : '-' },
    {
      title: 'Amallar', width: 100,
      render: (_, r) => (
        <Space>
          <Button size="small" icon={<EditOutlined />} onClick={() => handleEdit(r)} />
          <Popconfirm title="O'chirish?" onConfirm={() => handleDelete(r.id)}>
            <Button size="small" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Title level={3}>Foydalanuvchilar boshqaruvi</Title>
      <Card style={{ borderRadius: 12, marginBottom: 16 }}>
        <Space wrap>
          <Input
            placeholder="Ism yoki telefon"
            prefix={<SearchOutlined />}
            allowClear
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ width: 260 }}
          />
          <Select
            placeholder="Rol bo'yicha"
            allowClear
            style={{ width: 180 }}
            value={roleFilter}
            onChange={setRoleFilter}
            options={roles.map(r => ({ label: r.name, value: r.id }))}
          />
        </Space>
      </Card>
      <Card style={{ borderRadius: 12 }}>
        <Table
          dataSource={data}
          columns={columns}
          rowKey="id"
          loading={loading}
          pagination={{ current: page, total, pageSize: 20, onChange: p => { setPage(p); fetchData(p); } }}
          size="small"
          scroll={{ x: 700 }}
        />
      </Card>

      <Modal title="Foydalanuvchini tahrirlash" open={editModal} onOk={handleSave} onCancel={() => setEditModal(false)}>
        <Form form={form} layout="vertical">
          <Form.Item name="fullname" label="Ism" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="phone" label="Telefon" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="roles_id" label="Rol">
            <Select options={roles.map(r => ({ label: r.name, value: r.id }))} />
          </Form.Item>
          <Form.Item name="user_statusses_id" label="Status">
            <Select options={[
              { label: 'Aktiv', value: 1 }, { label: 'Nofaol', value: 2 },
              { label: 'Bloklangan', value: 3 }, { label: "O'chirilgan", value: 4 },
            ]} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
